import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getsuggestionHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "suggestion", ...action.payload }),
		);
		yield put({
			type: types.GET_SUGGESTION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SUGGESTION_ERROR,
			payload,
		});
	}
}

export function* getsuggestionWatcherSaga() {
	yield takeLatest(types.GET_SUGGESTION_START, getsuggestionHandlerSaga);
}

//create

//delete

function* deletesuggestionHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("suggestion", action.payload),
		);
		yield put({
			type: types.DELETE_SUGGESTION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SUGGESTION_ERROR,
			payload,
		});
	}
}

export function* deletesuggestionWatcherSaga() {
	yield takeLatest(types.DELETE_SUGGESTION_START, deletesuggestionHandlerSaga);
}

//update
